export enum WebsocketAction {
  ALERTS = 'alerts',
  APPOINTMENT_UPDATED = 'appointment.updated',
  AUTHORIZATION_RULES_DETECT_ISSUES = 'authorization-rules.detect-issues',
  AUTHORIZATION_RULES_REPROCESS_LOOKUPS = 'authorization-rules.reprocess-lookups',
  CLEARANCE_UPDATED = 'clearance.updated',
  DASHBOARD = 'dashboard',
  DASHBOARD_WEEK_VIEW = 'dashboard-week-view',
  ELIGIBILITY_INQUIRY_CONSOLE = 'eligibilities.pullFromConsole',
  ELIGIBILITY_INQUIRY_PATIENT_PORTAL = 'eligibilities.pullFromPatientPortal',
  EXPORT = 'export',
  IMPORT = 'import',
  LOCK = 'lock',
  MESSAGING_NEW_MESSAGE = 'new-message',
  MESSAGING_TYPING = 'typing',
  NOTE = 'note',
  PATIENT_RESULTS = 'patient.results',
  PATIENT_RETRIEVE = 'patient.retrieve',
  PATIENT_SEARCH = 'patient.search',
  PRIOR_AUTHORIZATION_INDEX = 'prior-authorization.index',
  PRIOR_AUTHORIZATION_SUBMIT = 'prior-authorization.submit',
  PRIOR_AUTHORIZATION_STATUS = 'prior-authorization.status',
  PRIOR_AUTHORIZATION_STATUS_CANCEL = 'prior-authorization.status-cancel',
  PROCEDURES_ESTIMATE = 'procedures.estimate',
  UNLOCK = 'unlock',
  VALIDATE_AVAILABLE_TIMES = 'scheduling.available-times.validate',
  WORKLIST_AUTOMATIONS = 'worklist.automations',
  WORKLIST_BUILD = 'worklist.build',
  WORKLIST_DELETE = 'worklist.delete',
  WORKLIST_DELETE_ERROR = 'worklist.delete.error',
  WORKLIST_PREVIEW = 'worklist.preview',
  WORKLIST_UPLOAD_FILES = 'worklist.upload-files',
  WORKLIST_MOVE_FILE = 'worklist.move-item-file',
  WORKLIST_CLASSIFY_DOCUMENT = 'worklist.classify-document',
  WORKLIST_AUTOMATION_ACTIVITY = 'worklist.automation-activity',
  TEXTRACT_FILE = 'textract.file',
}
